import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CiscoDialPlanFieldConfig } from '../models/generated/ziroModels';

@Injectable()
export class CiscoDialPlanFieldConfigResource {
  private http = inject(HttpClient);

  get(siteId: number): Observable<CiscoDialPlanFieldConfig[]> {
    return this.http.get<CiscoDialPlanFieldConfig[]>(`/services/cisco/field-configs/dial-plans?siteId=${siteId}`);
  }
}
